import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, TYPOGRAPHY } from './constants';
import sx from './sx';
import theme from './theme';
const Text = styled.span.withConfig({
  displayName: "Text",
  componentId: "sc-1s3uzov-0"
})(["", ";", ";", ";"], TYPOGRAPHY, COMMON, sx);
Text.defaultProps = {
  theme
};
Text.propTypes = {
  ...TYPOGRAPHY.propTypes,
  ...COMMON.propTypes,
  ...sx.propTypes,
  theme: PropTypes.object
};
export default Text;